import {} from './mutation-types';

export default {};
